"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableSizes = exports.sizes = void 0;
var sizes = Object.freeze({
  MEDIUM: "medium",
  SMALL: "small"
});
exports.sizes = sizes;
var availableSizes = Object.freeze(Object.values(sizes));
exports.availableSizes = availableSizes;
var componentArgs = {
  checked: {
    defaultValue: false,
    description: "Render a checked checkbox",
    control: {
      type: "boolean"
    },
    table: {
      type: {
        summary: "boolean"
      },
      defaultValue: {
        summary: "false"
      }
    },
    type: "boolean"
  },
  className: {
    table: {
      disable: true
    }
  },
  disabled: {
    defaultValue: false,
    description: "Render a disabled checkbox",
    control: {
      type: "boolean"
    },
    table: {
      type: {
        summary: "boolean"
      },
      defaultValue: {
        summary: "false"
      }
    },
    type: "boolean"
  },
  error: {
    defaultValue: false,
    description: "Render a checkbox in error state",
    control: {
      type: "boolean"
    },
    table: {
      type: {
        summary: "boolean"
      },
      defaultValue: {
        summary: "false"
      }
    },
    type: "boolean"
  },
  indeterminate: {
    defaultValue: false,
    description: "Render an indeterminate checkbox",
    control: {
      type: "boolean"
    },
    table: {
      type: {
        summary: "boolean"
      },
      defaultValue: {
        summary: "false"
      }
    },
    type: "boolean"
  },
  size: {
    control: {
      type: "select"
    },
    defaultValue: sizes.MEDIUM,
    description: "Size of the control",
    options: availableSizes,
    table: {
      type: {
        summary: "string"
      },
      defaultValue: {
        summary: sizes.MEDIUM
      }
    }
  }
};
exports.componentArgs = componentArgs;